import { forwardRef } from 'react'

export const Plus = forwardRef<SVGSVGElement, { color?: string; size?: number }>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99997 0C7.11632 0 6.39997 0.716344 6.39997 1.6V6.39961H1.6C0.716344 6.39961 0 7.11595 0 7.99961C0 8.88326 0.716344 9.59961 1.6 9.59961H6.39997V14.4C6.39997 15.2837 7.11632 16 7.99997 16C8.88363 16 9.59997 15.2837 9.59997 14.4V9.59961H14.4C15.2837 9.59961 16 8.88326 16 7.99961C16 7.11595 15.2837 6.39961 14.4 6.39961H9.59997V1.6C9.59997 0.716344 8.88363 0 7.99997 0Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default Plus
